import { createClient } from "@supabase/supabase-js";

const getEnv = () => {
  try {
    // Vite: import.meta.env is populated at build time (Vercel) or from .env.local (local dev)
    return typeof import.meta !== "undefined" ? import.meta.env : process.env || {};
  } catch {
    return {};
  }
};

const ENV = getEnv();

const SUPABASE_URL = (ENV.VITE_SUPABASE_URL || "").trim();
const SUPABASE_ANON_KEY = (ENV.VITE_SUPABASE_ANON_KEY || "").trim();

/** Singleton Supabase client. Set at load time if env present, or after fetching from backend. */
export let supabase = null;

/** Resolves when the Supabase client is ready from direct frontend env only. */
let readyPromise;

if (SUPABASE_URL && SUPABASE_ANON_KEY) {
  supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
  readyPromise = Promise.resolve();
} else {
  readyPromise = Promise.resolve();
  if (ENV.DEV && ENV.VITE_SUPPRESS_API_WARNINGS !== "true") {
    console.warn(
      "[supabaseClient] Direct Supabase client not configured. Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY."
    );
  }
}

/**
 * Wait for Supabase client to be ready (from env or from backend config). Call before using supabase.
 */
export function getSupabaseReady() {
  return readyPromise;
}

/**
 * Call this to get a short reason why auth might be disabled (for in-page diagnostics when DevTools aren't available).
 * Only accurate after getSupabaseReady() has resolved.
 */
export function getAuthConfigStatus() {
  if (supabase) return { configured: true, reason: null };
  return {
    configured: false,
    reason:
      "Supabase not configured: set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY for the frontend build.",
  };
}
